var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoreographIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1910",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 91.93,
    y1: 1375.86,
    x2: 1890.13,
    y2: 693.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec298f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2.55,
    y1: 1127.04,
    x2: 760.47,
    y2: 839.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00b5bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00a7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#009299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 531.14,
    y1: 737.12,
    x2: 1362.05,
    y2: 421.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#048ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0489c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0581bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0573a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06699a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Coreograph Colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1920,949.22c0,530.55-430.35,960.75-961.38,960.78-444.22,0-818.12-301.07-928.45-710.14,230.85-1.46,408.57-1.31,544.51-.53,81.81,125.1,223.22,207.76,383.91,207.75,253.11,0,458.23-205,458.21-457.84,0-160-82.12-300.83-206.53-382.69q0-272.38,0-544.76l-.24-.07C1619.06,132.15,1920,505.53,1920,949.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M706.86,698.22v502.17c-38.91-.41-82.78-.78-132.18-1.06-135.94-.78-313.66-.93-544.51.53A957.15,957.15,0,0,1,0,1024.07c.31-26.5.74-62.27,6.7-100.27,1.5-9.54,21.66-93,78.85-149.85,76.21-75.7,193.28-75.71,427.42-75.74q61.54,0,123.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1210.27,566.55v131.2c0,271.2-214.76,492.27-483.61,502.65-.53,0-1,0-1.57.06-4.27.12-7.7,0-18.23-.07V300.8c1.71-31.52,10.86-123,81.8-197.33,46.93-49.16,99-67.81,134.59-80.11,85.29-29.47,165.66-26.33,225-16.14q31.27,6.26,61.81,14.5l.24.07Q1210.26,294.18,1210.27,566.55Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreographIcon);
export default __webpack_public_path__ + "static/media/coreograph-icon.f492423b.svg";
export { ForwardRef as ReactComponent };